var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentWidgetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "19px",
  viewBox: "0 0 18 19",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "7CC4BA60-F592-4401-A700-8BD34CE48EFB")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Entry-Points",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "enrty-point_live-blog",
  transform: "translate(-577.000000, -365.000000)",
  stroke: "#001346"
}, /*#__PURE__*/React.createElement("g", {
  id: "bubble_live-blog",
  transform: "translate(577.000000, 365.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6,0.5 C16.1246705,0.5 16.5996705,0.712664744 16.9435029,1.05649712 C17.2873353,1.40032949 17.5,1.87532949 17.5,2.4 L17.5,2.4 L17.5,13.4333333 C17.5,13.9580038 17.2873353,14.4330038 16.9435029,14.7768362 C16.5996705,15.1206686 16.1246705,15.3333333 15.600016,15.3333333 L15.600016,15.3333333 L5.05359357,15.3329955 L0.5,18.1095128 L0.5,2.4 C0.5,1.87532949 0.712664744,1.40032949 1.05649712,1.05649712 C1.40032949,0.712664744 1.87532949,0.5 2.4,0.5 L2.4,0.5 L15.6,0.5 Z",
  id: "Combined-Shape-Copy-2"
}))))));
export default SvgCommentWidgetIcon;